import {

  DEFAULT_MODEL_TRY_ON_ETHNICITY,

  DEFAULT_MODEL_TRY_ON_MODEL_TYPE,

  MODEL_TRY_ON_ETHNICITY_OPTIONS,

  MODEL_TRY_ON_MODEL_TYPE_OPTIONS,

  isGarmentTypeAllowedForModel,

  resolveDefaultGarmentTypeForModel,

} from './modelStudioConfig';

import {

  MODEL_TRY_ON_PRESET_ASSET_REV,

  MODEL_TRY_ON_TRIPLE_IMPORT_SLOTS,

  buildTryOnPresetAssetPath,

  buildTryOnPresetDisplayUrl,

  isTryOnSystemPresetAssetUrl,

} from './modelTryOnPresetConfig';



/** @deprecated 13.4 起静态 fallback 复用 model-try-on-presets，保留常量仅供旧 URL 识别 */

export const MODEL_ETHNICITY_PRESET_ASSET_BASE = '/assets/model-ethnicity-presets';



/** 静态资源版本号：与试衣 fallback 图同步 */

export const MODEL_ETHNICITY_PRESET_ASSET_REV = MODEL_TRY_ON_PRESET_ASSET_REV;



const MODEL_ETHNICITY_MODEL_TYPES = MODEL_TRY_ON_MODEL_TYPE_OPTIONS.map((item) => item.value);

const MODEL_ETHNICITY_ETHNICITIES = MODEL_TRY_ON_ETHNICITY_OPTIONS.map((item) => item.value);



function isKnownModelEthnicityModelType(modelType) {

  return MODEL_ETHNICITY_MODEL_TYPES.includes(String(modelType || '').trim());

}



function isKnownModelEthnicityEthnicity(ethnicity) {

  return MODEL_ETHNICITY_ETHNICITIES.includes(String(ethnicity || '').trim());

}



function resolveEthnicityFallbackTryOnSlot(ethnicity) {

  const eth = String(ethnicity || '').trim();

  return MODEL_TRY_ON_TRIPLE_IMPORT_SLOTS.find((slot) => slot.ethnicity === eth) || null;

}



/**

 * 节点 13.4 / 14.4：fallback 复用 public/assets/model-try-on-presets 下已有 webp（兼容 png）。

 * 按默认衣物类型 + 人种槽位（asian/white/black）选取对应试衣静态图。

 */

export function buildModelEthnicityPresetAssetPath(modelType, ethnicity) {

  const model = String(modelType || '').trim();

  const eth = String(ethnicity || '').trim();

  if (!model || !eth) return '';

  if (!isKnownModelEthnicityModelType(model) || !isKnownModelEthnicityEthnicity(eth)) return '';



  const garmentType = resolveDefaultGarmentTypeForModel(model);

  if (!isGarmentTypeAllowedForModel(garmentType, model)) return '';



  const slot = resolveEthnicityFallbackTryOnSlot(eth);

  if (!slot) return '';

  return buildTryOnPresetAssetPath(model, garmentType, slot.index, slot.suffix);

}



/** 按模特性别 + 人种返回本地系统模特（复用试衣静态 assets） */

export function buildStaticModelEthnicityPresets(modelType, ethnicity) {

  const model = String(modelType || '').trim();

  const eth = String(ethnicity || '').trim();

  if (!model || !eth) return [];

  if (!isKnownModelEthnicityModelType(model) || !isKnownModelEthnicityEthnicity(eth)) return [];



  const url = buildModelEthnicityPresetAssetPath(model, eth);

  if (!url) return [];



  return [{

    id: `${model}-${eth}`,

    modelType: model,

    ethnicity: eth,

    sortOrder: 1,

    url,

    assetRev: MODEL_ETHNICITY_PRESET_ASSET_REV,

    source: 'static',

  }];

}



/** 是否为手持/万物穿戴系统模特静态资源地址（含 13.4 试衣 fallback 路径） */

export function isModelEthnicitySystemPresetAssetUrl(url) {

  const value = String(url || '').trim();

  if (!value) return false;

  if (value.includes(`${MODEL_ETHNICITY_PRESET_ASSET_BASE}/`) || value.includes('model-ethnicity-presets/')) {

    return true;

  }

  return isTryOnSystemPresetAssetUrl(value) && Boolean(inferModelEthnicityPresetIdFromAssetUrl(value));

}



/** 系统模特静态图展示地址（试衣 fallback 图走 buildTryOnPresetDisplayUrl） */

export function buildModelEthnicityPresetDisplayUrl(preset) {

  const url = String(preset?.url || '').trim();

  if (!url) return '';

  if (isTryOnSystemPresetAssetUrl(url)) {

    return buildTryOnPresetDisplayUrl(preset);

  }

  if (!isModelEthnicitySystemPresetAssetUrl(url)) return '';

  const rev = preset?.assetRev || MODEL_ETHNICITY_PRESET_ASSET_REV;

  const sep = url.includes('?') ? '&' : '?';

  return `${url}${sep}v=${encodeURIComponent(String(rev))}`;

}



/** 按 presetId 查找当前 modelType + ethnicity 下的静态系统模特 */

export function findModelEthnicityPresetById(modelType, ethnicity, presetId) {

  const id = String(presetId || '').trim();

  if (!id) return null;

  return buildStaticModelEthnicityPresets(modelType, ethnicity).find((item) => String(item.id) === id) || null;

}



/** 从系统模特资源 URL 反推 presetId，如 female-asian */

export function inferModelEthnicityPresetIdFromAssetUrl(url) {

  const value = String(url || '').trim();

  const legacyMatch = value.match(/model-ethnicity-presets\/([^/]+)\/\1-([^./?]+)\.(?:png|webp)/i);

  if (legacyMatch) {

    return `${legacyMatch[1]}-${legacyMatch[2]}`;

  }



  const tryOnMatch = value.match(/model-try-on-presets\/([^/]+)\/([^/]+)\/\1-\2-(\d+)-([^./?]+)\.(?:png|webp)/i);

  if (!tryOnMatch) return '';

  const model = tryOnMatch[1];

  const suffix = tryOnMatch[4];

  const slot = MODEL_TRY_ON_TRIPLE_IMPORT_SLOTS.find((item) => item.suffix === suffix || item.ethnicity === suffix);

  if (!slot) return '';

  return `${model}-${slot.ethnicity}`;

}



export {

  DEFAULT_MODEL_TRY_ON_ETHNICITY,

  DEFAULT_MODEL_TRY_ON_MODEL_TYPE,

};


